
import { IonIcon, IonItem, IonLabel, IonList } from '@ionic/react'
import React from 'react'
import Page from '../components/Page'
import openLink from '../lib/openLink';

export default class extends React.Component {
  render() {
    return (
      <Page title="Horadric Cube" large>

        <IonList>
        
          {/* <IonItem routerLink="#" onClick={() => {
              openLink('https://diablo2.diablowiki.net/Crafting_Recipes')
            }}>
            <IonLabel>
              <h1>Crafting Recipes</h1>
              <p>The most powerful item creation. View on diablowiki.net</p>
            </IonLabel>
          </IonItem>
          <IonItem routerLink="#" onClick={() => {
              openLink('https://diablo2.diablowiki.net/Horadric_Cube_Recipes')
            }}>
            <IonLabel>
              <h1>All other cube recipes</h1>
              <p>Runes, sockets, upgrades, repairs, recycling, item creation, rerolls and respecs. View on diablowiki.net</p>
            </IonLabel>
          </IonItem> */}

          

          <IonItem routerLink="/cuberecipes/upgradeItems">
            <IonLabel>
              <h1>Upgrading items</h1>
              <p>Unique to Exceptional etc.</p>
            </IonLabel>
          </IonItem>
          <IonItem button onClick={() => {
              openLink('https://diablo2.diablowiki.net/Crafting_Recipes')
            }}>
            <IonLabel>
              <h1>Crafting Recipes</h1>
              <p>The most powerful item creation. View on diablowiki.net for now</p>
            </IonLabel>
          </IonItem>
          <IonItem routerLink="/cuberecipes/runes">
            <IonLabel>
              <h1>Runes</h1>
              <p>Transmute into higher runes</p>
            </IonLabel>
          </IonItem>
          <IonItem routerLink="/cuberecipes/gems">
            <IonLabel>
              <h1>Gems</h1>
              <p>Transmute into more perfect gems</p>
            </IonLabel>
          </IonItem>
          <IonItem routerLink="/cuberecipes/preparation">
            <IonLabel>
              <h1>Runeword preparation</h1>
              <p>Remove sockets, add sockets and increase quality</p>
            </IonLabel>
          </IonItem>
          <IonItem routerLink="/cuberecipes/repairesrecharges">
            <IonLabel>
              <h1>Repairs and Recharges</h1>
              <p>For armors and weapons</p>
            </IonLabel>
          </IonItem>
          <IonItem routerLink="/cuberecipes/recycling">
            <IonLabel>
              <h1>Recycling recipes</h1>
              <p>Turn amulets into rings and so on...</p>
            </IonLabel>
          </IonItem>
        </IonList>
      </Page>
    )
  }
}